module.exports = __webpack_public_path__ + "static/media/19ESCAP50.96e21c23.jpg";